import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from './useAccount';

const useCompliances = ({ positionId, branchIds, isActive, enabled = true }) => {
  const { accountId } = useAccount();

  const storeKey = ['compliances', accountId, positionId, branchIds, isActive];

  const { isLoading, data, refetch } = useQuery(
    storeKey,
    () => api.fetchCompliances({ accountId, positionId, branchIds, isActive }),
    {
      enabled: enabled && !!positionId && branchIds?.length > 0,
      staleTime: 0,
      cacheTime: 0
    }
  );

  return {
    refetch,
    isLoading,
    data: data?.data || []
  };
};

export default useCompliances;
